import { Modal } from 'antd';
import React from 'react';
import { AssetCatalogResponse } from 'services/assetconfig';
import AssetCatalogList from './AssetCatalogListTable';

export type AssetSearchModalProps = {
  visible: boolean;
  onCancel: () => void;
  setAsset: (page: AssetCatalogResponse) => void;
  status?:string;
};

const AssetCatalogSearchModal = ({
  onCancel,
  visible,
  setAsset,
  status
}: AssetSearchModalProps) => {
  return (
    <Modal visible={visible} onCancel={onCancel} width={1200} destroyOnClose>
      <AssetCatalogList
      status={status}
        onAssetSelect={(e): any => {
          setAsset(e);
        }}
        visible={visible}
        onCancel={onCancel}
        hideActionsButton
        hideAddButton
      />
    </Modal>
  );
};

export default AssetCatalogSearchModal;
